import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c02961e")

_pushScopeId("data-v-4c02961e")
const _hoisted_1 = { class: "data second" }
const _hoisted_2 = { class: "input-border first" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { for: "name" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Název skupiny uživatelů", -1)
const _hoisted_5 = { class: "group" }
const _hoisted_6 = { class: "border-gr short" }
const _hoisted_7 = { class: "end-form" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
              type: "text",
              autocomplete: "nope"
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("button", {
        class: "convert",
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addConsumerGroup && _ctx.addConsumerGroup(...args)))
      }, "Uložit")
    ])
  ], 64))
})